export default __webpack_public_path__ + "static/media/logo-pukka.b29f2304.svg";